<main id="main" class="main">
  <!-- Header -->
  <div class="row m-1">
    <div
      class="col-12 col-md-12 d-flex justify-content-between"
      style="background: #5d7c9b !important; font-size: 14px"
    >
      <h6 class="title">
        Travel Commissions &nbsp;&nbsp;
        <i class="bi bi-info-circle"></i>
      </h6>
      <button
        class="btn btn-primary"
        style="font-size: 12px"
        (click)="add()"
        title="Add"
      >
        Add
      </button>
    </div>
  </div>

  <!-- Datatable -->
  <div class="row m-1 mt-4">
    <div class="table-responsive">
      <table
        datatable
        [dtOptions]="dtOptions"
        [dtTrigger]="dtTrigger"
        id="DataTables_Table_1"
        class="table text-nowrap"
      >
        <thead>
          <tr>
            <th>#</th>
            <th>Name</th>
            <th>Date</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of data; let i = index">
            <td>{{ i + 1 }}</td>
            <td>{{ item.name }}</td>
            <td>{{ item.date | date : "MMMM yyyy" }}</td>
            <td>
              <div style="min-width: 20px" data-bs-target="showmemberlist" class="d-flex gap-3">
                <a
                  class="viewicon"
                  title="View PDF"
                  data-toggle="tooltip"
                  style="cursor: pointer"
                >
                  <i
                    class="bi bi-file-earmark-pdf-fill"
                    style="color: rgb(159, 56, 56); cursor: pointer"
                    (click)="viewPdf(item)"
                  ></i>
                </a>
                <a class="viewicon" title="Delete" data-toggle="tooltip">
                  <i
                    class="bi bi-trash cursor: pointer;"
                    style="color: rgb(56, 76, 159); cursor: pointer"
                    (click)="deleteItem(item.id)"
                  >
                  </i>
                </a>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</main>

<div
  class="modal viewModal"
  id="advisor-report-modal"
  role="dialog"
  aria-labelledby="modal-label"
  style="display: none"
>
  <div
    class="modal-dialog modal-lg modal-dialog-centered"
    role="document"
    style
    id="heightWidthModal2"
  >
    <div class="modal-content" id="modal-content">
      <div class="modal-header" style="height: 40px">
        <div class="col-11 text-center">
          <h6 class="modal-title">{{ title }}</h6>
        </div>
        <div class="col-1 text-end ms-2 ms-md-2">
          <i
            style="margin-right: 20px"
            class="bi bi-x-circle"
            role="button"
            aria-hidden="true"
            data-bs-dismiss="modal"
          ></i>
        </div>
      </div>

      <div class="modal-body" id="modal-body1">
        <pdf-viewer
          *ngIf="true"
          [src]="pdfSrc"
          id="pdf-viewer"
          style="width: 100%"
          class="providersSize"
        ></pdf-viewer>
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-sm btn-light"
          data-bs-dismiss="modal"
          id="closeButton"
        >
          Close
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Model For Add -->
<div
  class="modal fade"
  data-bs-backdrop="static"
  id="basicModal1"
  tabindex="-1"
>
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h6 class="modal-title">Add Travel Commission</h6>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
      </div>
      <div class="modal-body">
        <div class="input-wrapper row">
          <div class="form-group col-6">
            <label for="Corporation" class="Corporation">
              Month
              <span style="color: red">*</span>
            </label>
            <input
              type="text"
              [(ngModel)]="month"
              class="form-control"
              placeholder="Select Month"
              bsDatepicker  
              [bsConfig]="{ dateInputFormat: 'MMM YYYY', minMode: 'month' ,showWeekNumbers: false}"
              [maxDate]="maxDateForPicker"
            />
          </div>
          <div class="form-group col-6">
            <label for="Corporation" class="Corporation">
              File
              <span style="color: red">*</span>
            </label>

            <input
              #inputFile
              type="file"
              class="form-control"
              placeholder="Upload File"
              (change)="onFileSelected($event)"
            />
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-secondary"
          id="closeaddadmin"
          data-bs-dismiss="modal"
          #closemodel
          (click)="reset()"
        >
          Close
        </button>
        <button type="button" class="btn btn-primary" (click)="submit()">
          Save
        </button>
      </div>
    </div>
  </div>
</div>
